import 'twin.macro';
import _isEmpty from 'lodash-es/isEmpty';
import React from 'react';
import SimpleNarrowPage from '@teetsh/app/src/components/Layouts/SimpleNarrowPage';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateEmptySequence } from 'queries/sequences/useCreateSequence';
import tw from 'twin.macro';
import { NewOptionCard } from '@teetsh/app/src/components/Cards/NewOptionCard';
import {
  NewFDPAloneIllustration,
  NewSequenceIllustraction,
} from '@teetsh/app/src/containers/Sequences/Home/SequencesIllustrations';
import { OnboardingModulePageWrapper } from '@teetsh/app/src/components/OnboardingModulePageWrapper';

export function NewSequenceStart() {
  const navigate = useNavigate();
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const folderIdParam = urlSearchParams.get('folderId') || undefined;
  const folderId = _isEmpty(folderIdParam) ? undefined : folderIdParam;
  const { t } = useTranslation(['sequence', 'common']);

  const createEmptySequence = useCreateEmptySequence();
  const onCreate = async () => {
    await createEmptySequence({ folderId });
  };

  return (
    <OnboardingModulePageWrapper
      title={t('sequence:createNewSequence')}
      onBack={() => navigate(-1)}
    >
      <SimpleNarrowPage width="5xl">
        <div
          css={[
            tw`mb-6 text-center text-balance grid justify-center gap-4 grid-cols-1 auto-rows-fr lg:grid-cols-2`,
          ]}
        >
          <NewOptionCard
            title={t('sequence:newCards.ficheDePrep.title')}
            description={t('sequence:newCards.ficheDePrep.description')}
            icon={<NewFDPAloneIllustration />}
            onClick={() => navigate('/fiches-de-prep/new')}
          />
          <NewOptionCard
            title={t('sequence:newCards.sequence.title')}
            description={t('sequence:newCards.sequence.description')}
            icon={<NewSequenceIllustraction />}
            onClick={onCreate}
          />
        </div>
      </SimpleNarrowPage>
    </OnboardingModulePageWrapper>
  );
}
